module.exports = __webpack_public_path__ + "static/media/griffindcode.3210b72e.png";